import BaseAPI from './base';

class CardService extends BaseAPI {
  getCards = async () => {
    const url = '/Cards';

    return this.getJson(url);
  };
}

export default new CardService();
